var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7883 120.613L119.641 65.5423L84.6924 67.8811L24.7883 120.613Z",
    fill: "#1F28BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0435 23.3202L84.8465 21.7412L55.8786 9.18489L45.7044 0.635559L58.8203 2.39842L87.7882 14.9547L98.0435 23.3202Z",
    fill: "url(#paint0_linear_3288_1536)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.692 67.8811L22.3139 40.8461L55.8782 9.18494L84.8461 21.7413L84.692 67.8811Z",
    fill: "url(#paint1_linear_3288_1536)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7009 0.638306L0.126587 13.7408L22.3135 40.8461L55.8804 9.18493L45.7009 0.638306Z",
    fill: "url(#paint2_linear_3288_1536)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.692 67.8811L24.7879 120.613L22.3139 40.8461L84.692 67.8811Z",
    fill: "url(#paint3_linear_3288_1536)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7874 120.613L0.126587 13.7408L22.3135 40.8461L24.7874 120.613Z",
    fill: "url(#paint4_linear_3288_1536)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6349 66.9645C71.8442 62.4627 22.4198 45.6209 28.0193 117.795L24.8018 120.621L22.3279 40.8596L55.8786 9.18488L59.8856 11.7562C59.8856 11.7562 46.3398 18.5156 44.5229 29.6687L68.9891 14.6816L77.2679 18.813L45.0934 37.0445C45.3941 38.0089 45.7721 38.9474 46.2236 39.8511L81.1018 20.1135L84.8438 21.7358L47.8593 42.663C52.6963 49.901 63.0922 58.115 82.6349 66.9645Z",
    fill: "url(#paint5_linear_3288_1536)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M84.614 67.846C83.9678 67.5594 83.3324 67.2809 82.7052 66.9943C83.7326 67.4269 84.395 67.7378 84.614 67.846Z",
    fill: "url(#paint6_linear_3288_1536)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7871 120.613C24.7871 120.613 -8.60951 -11.1907 55.8801 9.18493L45.7005 0.638306L0.126282 13.7408L24.7871 120.613Z",
    fill: "url(#paint7_linear_3288_1536)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6697 11.1127C60.6697 11.1127 74.3425 8.43592 90.8002 17.4124L87.7882 14.952L58.8203 2.3984L45.7018 0.638245L55.8814 9.18487L60.6697 11.1127Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0408 23.3229L119.641 65.5423L84.6924 67.8811L84.8466 21.7412L98.0408 23.3229Z",
    fill: "#1E33E1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3929 13.4244C53.4295 12.4317 54.7332 11.7631 56.1441 11.5004C57.5551 11.2377 59.0121 11.3924 60.3365 11.9454C67.5987 14.9737 80.966 20.4461 81.1093 20.1189C81.277 19.7296 62.6103 11.2749 57.457 8.99832C56.6753 8.65251 55.9426 8.20524 55.2778 7.66806C49.8325 3.27173 45.9255 0.367877 45.7038 0.638255C45.52 0.859964 47.9993 3.27443 51.936 6.78122C52.2978 7.10241 52.5885 7.49573 52.7892 7.93592C52.99 8.37611 53.0965 8.85344 53.1019 9.33723C53.1072 9.82103 53.0113 10.3006 52.8203 10.7451C52.6293 11.1896 52.3474 11.5893 51.9927 11.9184C45.5308 17.9127 34.3697 28.3708 27.7239 34.6111C27.0384 35.2545 26.229 35.7517 25.3452 36.0724C24.4614 36.393 23.5216 36.5305 22.5829 36.4763C21.6443 36.4222 20.7265 36.1776 19.8854 35.7575C19.0443 35.3374 18.2974 34.7505 17.6904 34.0325C10.4552 25.4751 0.253935 13.6461 0.129563 13.7543C0.00519092 13.8624 11.5988 28.7764 18.7043 37.688C20.5057 39.9453 21.5349 42.7213 21.6405 45.6074C22.1813 60.4187 23.2628 84.2713 23.4277 86.4695C23.598 88.9164 23.7413 90.2548 23.8495 90.2548C23.9576 90.2548 24.0171 88.9029 24.036 86.4533C24.0523 84.3092 23.6927 62.3383 23.3439 47.8731C23.3288 47.2573 23.4684 46.6476 23.75 46.0997C24.0316 45.5518 24.4461 45.0833 24.9556 44.737C25.4651 44.3908 26.0533 44.178 26.6664 44.1179C27.2794 44.0579 27.8978 44.1526 28.4648 44.3934C40.4667 49.4846 68.4261 61.2974 70.1673 61.9679C72.3168 62.779 73.528 63.1927 73.5767 63.0846C73.6254 62.9764 72.4952 62.3681 70.4323 61.3596C68.7695 60.5484 41.5022 48.4274 29.3895 43.0686C28.7798 42.7979 28.2464 42.3811 27.8364 41.8551C27.4263 41.329 27.1523 40.71 27.0387 40.0527C26.9251 39.3955 26.9753 38.7204 27.1849 38.0872C27.3945 37.454 27.757 36.8823 28.2404 36.4227C34.4509 30.5122 45.6335 19.8945 52.3929 13.4244Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M24.7883 120.613L115.737 65.8018L98.0408 23.3229L119.641 65.5423L24.7883 120.613Z",
    fill: "url(#paint8_linear_3288_1536)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1889 9.97437C25.8618 8.7036 23.1337 8.30615 20.0974 9.09024C17.0611 9.87434 14.8629 11.5236 15.1901 12.8079C15.5173 14.0922 18.2453 14.4762 21.2843 13.6948C24.3233 12.9134 26.5188 11.2451 26.1889 9.97437Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0393 12.789C9.52248 13.1811 8.42206 14.0138 8.58698 14.6492C8.75191 15.2846 10.1146 15.4847 11.6341 15.0927C13.1536 14.7006 14.2513 13.8678 14.0891 13.2325C13.9269 12.5971 12.5588 12.397 11.0393 12.789Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3288_1536",
    x1: 130.61,
    y1: 37.6691,
    x2: 11.2611,
    y2: -14.3099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F6AED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#36A9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BD7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3288_1536",
    x1: 103.785,
    y1: 83.8489,
    x2: 14.0634,
    y2: -10.1036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E63FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#357EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1AA2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3288_1536",
    x1: 99.3402,
    y1: 88.0873,
    x2: 9.62084,
    y2: -5.86408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F6AED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#36A9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BD7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3288_1536",
    x1: 72.9502,
    y1: 113.293,
    x2: -16.7716,
    y2: 19.3409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3539DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#255FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27A1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3288_1536",
    x1: 64.3549,
    y1: 121.506,
    x2: -25.3683,
    y2: 27.5498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C55E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2A92FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EC9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3288_1536",
    x1: 40.5025,
    y1: 123.157,
    x2: 61.2514,
    y2: 3.13662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1990FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DD7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3288_1536",
    x1: 73.0528,
    y1: 128.784,
    x2: 93.7991,
    y2: 8.76032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1990FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DD7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3288_1536",
    x1: 107.697,
    y1: 92.1394,
    x2: -12.3222,
    y2: 39.9359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8590FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5CCFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61FDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3288_1536",
    x1: 41.6489,
    y1: 133.923,
    x2: 114.613,
    y2: 36.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C55E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2A92FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EC9FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.c2453901bdd570d677d4210be610e94e.svg";
export { ForwardRef as ReactComponent };